import React from "react";
// import { Analytics } from "@vercel/analytics/react";
import Navigation from "./components/Navigation/Navigation";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Achievements from "./components/Achievements/Achievements";
import Footer from "./components/Footer/Footer";
function App() {
  const handleHeroClick = () => {
    const workSection = document.getElementById("work");
    workSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div style={{ background: "#0a0e1a", color: "white", overflowX: "hidden" }}>
      <div className="scan-effect"></div>
      <Navigation />
      <Hero onCtaClick={handleHeroClick} />
      <About />
      <Projects />
      <Achievements />
      <Footer />
      {/* <Analytics /> */}
    </div>
  );
}

export default App;
